import React, {createContext, useReducer} from 'react';
import viewReducer from '../reducers/viewReducer.js';

const defaultView = {
	drawer: false,
	locale: 'en',
	pageType: 'poi',
	pageNo: 0,
	originalPoi: {},
	poi: {},
	pois: [],
};

export const ViewContext = createContext();

export function ViewProvider(props) {
	const [view, dispatch] = useReducer(viewReducer, defaultView);

	return <ViewContext.Provider value={{view, dispatch}}>{props.children}</ViewContext.Provider>;
}
